<script setup lang="ts">
import { TSite } from "@/data/api/kili/sites/types/sites.type";
import { useTypedIntl } from "@/locales/typed-intl";

import Message from "primevue/message";

import SiteAddress from "@/components/site/site-address.vue";
import ColoredBadge from "@/components/ui/colored-badge.vue";

interface IProps {
  site: TSite;
}

interface IEmits {
  (e: "select", site: TSite): void;
}

const props = defineProps<IProps>();
const emits = defineEmits<IEmits>();
const { t, k } = useTypedIntl();
</script>

<template>
  <div
    aria-haspopup="dialog"
    :aria-label="props.site.name"
    class="bg-white flex flex-col gap-2 w-full rounded-2xl border p-4 hover:border-brand"
    role="button"
    tabindex="0"
    @click="emits('select', props.site)"
    @keydown.enter="emits('select', props.site)"
  >
    <div class="flex w-full truncate text-ellipsis flex-row items-center justify-start gap-4">
      <ColoredBadge
        class="shrink-0"
        :name="props.site.name"
      />

      <div class="flex w-full truncate flex-col gap-0">
        <h3 class="cursor-pointer w-fit text-base font-semibold">
          {{ props.site.name }}
        </h3>
        <SiteAddress :address="props.site.siteAddressDto" />
      </div>
    </div>

    <Message
      v-if="props.site.programingIsSuspended"
      icon="pi pi-info-circle"
      :pt="{
        content: {
          class: 'bg-surface-warning',
        },
      }"
      severity="warn"
    >
      <span class="text-sm font-normal">
        {{ t(k.control.piloting.siteProgramingSuspendedWarning) }}
      </span>
    </Message>
  </div>
</template>
